import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import {
    HistoryType,
    PatientHistory,
} from '../../models/patient-history';

const getPatientHistoryHashSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<PatientHistory>) => memoize((
        type: HistoryType
    ) => Object
        .keys(byId)
        .filter(x => byId[x]!.historyType === type)
        .reduce(
            (prevValue, x) => {
                if (type === HistoryType.DrugHistory || type === HistoryType.FallHistory) {
                    prevValue[byId[x]!.code] = {
                        id: byId[x]!.code,
                        date: byId[x]!.createdDate,
                        refId: x
                    } as PatientPortalDataMerge;
                } else {
                    prevValue[x] = {
                        id: x,
                        date: byId[x]!.createdDate
                    } as PatientPortalDataMerge;
                }
                return prevValue;
            },
            {} as Dictionary<PatientPortalDataMerge>
        )
    )
);

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getPatientHistory: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<PatientHistory> => state.byId[id || ''],
    getPatientHistoryHash: (
        state: State,
        type: HistoryType
    ): Dictionary<PatientPortalDataMerge> => getPatientHistoryHashSelector(state)(type),
    getPatientHistoryIds: (
        state: State,
        type: HistoryType
    ): Undefinable<number[]> => state.byType[type]
};
